import styled from '@emotion/styled';
import { Magnetic } from "../../styles";
export const StyledMenuItem = styled('div') `
	width: ${Magnetic.formControlCoreWidth};
	background-color: ${(props) => props.backgroundColor || Magnetic.colorNeutral10};
	border: ${Magnetic.buttonFlatBorder};
	.listItem-style {
		display: ${Magnetic.menuItemDisplay};
		align-items: ${Magnetic.menuItemAlignItems};
		font-weight: ${Magnetic.fontWeightHeavy};
		list-style: none;
		cursor: ${Magnetic.linkBaseCursor};
		border-radius: ${Magnetic.switchTrackTop} 0 0 ${Magnetic.switchTrackLeft};
		padding: ${Magnetic.slatPadding};
		.icon {
			width: 24px;
			font-size: ${Magnetic.fontSize22};
			text-align: ${Magnetic.menuItemAlignItems};
			box-sizing: ${Magnetic.formControlCoreBoxSizing};
		}
		.left-node {
			padding-left: ${Magnetic.spacer20};
		}
		.description {
			display: ${Magnetic.menuItemDisplay};
			flex: 1 1 auto;
			justify-content: space-between;
		}
	}
	:hover {
		background-color: ${Magnetic.colorBrand20};
		color: ${Magnetic.colorNeutral80};
	}
	.selected {
		background: ${(props) => props.selectedBackgroundColor || Magnetic.colorBrand60};
		color: ${Magnetic.colorWhite};
	}
	.disabled {
		color: ${Magnetic.colorNeutral50};
		cursor: ${Magnetic.disabledCursor};
	}
	.disabled:hover,
	[disabled]:hover {
		background-color: transparent;
	}
	@media screen and (max-width: ${Magnetic.modalMediumMaxWidth}) {
		.hide-description {
			display: none;
		}
	}
`;
export const StyledPrefixIcon = styled('span') `
	backgroundcolor: ${Magnetic.uamAlertColor};
	color: ${Magnetic.uamAlertColor};
	padding-right: ${Magnetic.spacer12};
`;
//# sourceMappingURL=MenuListItem.style.js.map